// From: https://github.com/dnmtvf/vue-lazysizes
// Reloads lazysizes when src is updated dynamically

export default {
  name: 'lazysizes',
  directive: {
    inserted(el, binding, vnode) {
      if (vnode.tag !== 'img') {
        throw new Error(`${vnode.tag} is wrong element, use img element instead`);
      }

      el.classList.add('lazyload');
    },
    // beforeUpdate(el) {
    //   el.classList.remove('lazyloaded');
    //   el.classList.add('lazyload');
    // },
    // updated(el) {
      // el.classList.remove('lazyloaded');
      // el.classList.add('lazyload');
      // const {
      //   data: {
      //     attrs: { 'data-src': src },
      //   },
      // } = vnode;
      // const {
      //   data: {
      //     attrs: { 'data-src': oldSrc },
      //   },
      // } = oldVnode;

      // if (src === oldSrc) {
      //   return;
      // }
      // console.log('ehhlo?!')

      // el.classList.remove('lazyloaded');
      // el.classList.add('lazyload');
    // },
  }
}